// import {convertRowsToData} from '../utils/dataUtils'

export default function MulitDataDataController(pages, currentPage, dataControllerClass, config) {
  let currentData
  if (pages.isMulti) {
    if (!currentPage || !pages.data.find(p => p.id === currentPage)) currentPage = pages.data[0].id
    currentData = pages.data.find(p => p.id === currentPage).data
  } else {
    currentData = pages.data
  }
  return dataControllerClass(currentData, config)
}
